import { MOBILE, TABLET, EXTRA_LARGE } from "@minerva-analytics/pantheon";

export const DARK_GRAY = `#2E2E2E`;
export const TRANSPARENT = `transparent`;
export const RED = `#ED2E31`;
export const LIGHT_GRAY = `#979797`;
export const WHITE = `#FFFFFF`;
export const GRAY = `#6C6C6C`;
export const BROWN = `#D7BEA6`;
export const LIGHT_RED = `#F37D7F`;

const starterTheme = {
  AppLink: `

  `,
  Background: `

  `,
  BodyText: `
  `,
  Card: `
    padding: 3rem 0;
    max-width: 40rem;
    width: 90%;
    margin-bottom: 2.5rem;
    box-sizing: border-box;
  `,
  Button: `
    font-family: 'Avenir Next Condensed', sans-serif;
    letter-spacing: 0.55px;
    background-color: ${RED};
    z-index: 1;
    border-radius: 5px;
    min-height: 37px;
    :hover {
      background-color: ${LIGHT_RED};
      transition: 0.5s;
    }
  `,
  ExternalLink: `
  `,
  Image: `
    @media (max-width: ${MOBILE}){
      height: 300px;
      width: 300px;
    }
  `,
  Input: `
    border: none;
    font-family: OpenSans, sans-serif;
    font-size: 16px;
    margin-right: 15px;
    @media (max-width: ${MOBILE}){
      margin-right: 0px;
      margin-bottom: 15px;
    }
  `,
  LoadingSpinner: `

  `,
  PiwikButton: `

  `,
  Title: `
    font-size: 42px;
    font-family: 'Abril Fatface', cursive;
    line-height: 54px;
    letter-spacing: 1.05px;
    @media (min-width: ${EXTRA_LARGE}) {
      width: 620px;
    }
    @media (max-width: ${TABLET}) {
      text-align: left;
      width: 90%;
    }
    @media (max-width: ${MOBILE}) {
      font-size: 32px;
    }
  `,
  H3: `
    font-size: 35px;
    font-family: 'Abril Fatface', cursive;
    line-height: 50px;
    letter-spacing: 0.85px;
    color: ${DARK_GRAY};
    width: 590px;
    text-align: left;
    @media (max-width: ${MOBILE}) {
      width: 95%;
    }
  `,
  BodyTextLarge: `
    font-family: 'Inter', sans-serif;
    font-weight: 400;
  `,
  SocialPageButton: `

  `,
  SubTitle: `
    font-family: 'Inter', sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 33px;
    text-align: left;
    width: 100%;
    letter-spacing: 0.68px;
    color: ${GRAY};
    @media (min-width: ${EXTRA_LARGE}) {
      width: 630px;
    }
  `,
  BurgerMenu: `
  `,
  Footer: `
    background-color: ${DARK_GRAY};
    padding-top: 10px;
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 13px;
  `,
  IconButton: `
    background-color: ${RED};
    margin-right: 0.5rem;
    :hover {
      background-color: ${LIGHT_RED};
      transition: 0.5s;
    }
    :hover {
      background-color: ${LIGHT_RED};
    }
  `,
  FacebookShareButton: `
  `,
  TwitterShareButton: `
  `,
  EmailShareButton: `
  `,
  Logo: `
  `,
};

export { starterTheme };
